import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 13.5a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0M27.408 16.184a6.5 6.5 0 0 0-2.906-.684 1 1 0 1 1-.004-2 8.48 8.48 0 0 1 6.803 3.401 1 1 0 0 1-1.602 1.198 6.5 6.5 0 0 0-2.29-1.915M7.498 15.5a6.48 6.48 0 0 0-5.197 2.599A1 1 0 0 1 .7 16.9 8.48 8.48 0 0 1 7.502 13.5a1 1 0 1 1-.004 2"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 23.503a7.01 7.01 0 0 0-6.301 3.936A1 1 0 0 1 7.9 26.56a9.012 9.012 0 0 1 16.198 0 1 1 0 1 1-1.798.878A7.01 7.01 0 0 0 16 23.503M8.241 7.594A3 3 0 1 0 7.5 13.5a1 1 0 1 1 .002 2 5 5 0 1 1 4.906-5.937 1 1 0 1 1-1.964.374A3 3 0 0 0 8.24 7.595M25.432 7.647a3 3 0 0 0-3.875 2.29 1 1 0 0 1-1.964-.374 5 5 0 1 1 4.906 5.937 1 1 0 1 1 .002-2 3 3 0 0 0 .931-5.853"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconUsersThree = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconUsersThree);
export default Memo;
